import React, { Component } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import classNames from 'classnames';
import { getFontFamily } from '../SiteThemeProvider';
import Video from '../Video';
import getSectionBackgroundStyle from '../lib/getSectionBackgroundStyle';

const VIDEO_TYPE = /video\/(mp4|webm|ogg)$/i;
const IMAGE_TYPE = /image\/.*$/i;

class Section extends Component {
  getBackground() {
    const { section, classes } = this.props;
    const { data, styles } = section;
    const media = data.backgroundMedia || {};

    if (VIDEO_TYPE.test(media.type) || IMAGE_TYPE.test(media.type)) {
      return (
        <div className={classes.fillParent}>
          {VIDEO_TYPE.test(media.type) && <Video src={media.url} type={media.type} />}
          <div
            className={classNames(
              classes.fillParent,
              (VIDEO_TYPE.test(media.type) || data.removeBackgroundImageOnMobile) &&
                classes.hideOnMobile,
            )}
            style={{ backgroundColor: styles.backgroundColor }}
          />
        </div>
      );
    }

    return null;
  }

  render() {
    const {
      className,
      rootClassName,
      section,
      classes,
      children,
      withPadding,
      withOpenDialog,
      style,
      withBackground,
    } = this.props;
    const { data } = section;

    return (
      <section
        id={section.id}
        className={classNames(
          classes.root,
          data.removeBackgroundImageOnMobile && classes.rootMobileNoImage,
          withPadding && classes.rootWithPadding,
          rootClassName,
          withOpenDialog && classes.withOpenDialog,
        )}
        style={withBackground ? getSectionBackgroundStyle(section, style) : undefined}
      >
        {withBackground && this.getBackground()}
        <div className={classNames(classes.content, className)}>{children}</div>
      </section>
    );
  }
}

Section.propTypes = {
  section: PropTypes.object.isRequired,
  site: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  rootClassName: PropTypes.string,
  children: PropTypes.node,
  withPadding: PropTypes.bool,
  withOpenDialog: PropTypes.bool,
  style: PropTypes.object,
  withBackground: PropTypes.bool,
};

Section.defaultProps = {
  className: null,
  rootClassName: null,
  children: null,
  withPadding: false,
  withOpenDialog: false,
  style: null,
  withBackground: true,
};

const stylesheet = theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    boxSizing: 'border-box',
    backgroundPosition: 'center',
    fontFamily: props => getFontFamily(props.site),
    position: 'relative',
    overflow: 'hidden',
  },
  fillParent: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    overflow: 'hidden',
  },
  content: {
    position: 'relative',
    maxWidth: theme.breakpoints.values.lg,
    width: '100%',
  },
  rootWithPadding: {
    padding: [theme.spacing.xlarge, theme.spacing.large],
    [theme.breakpoints.down('sm')]: {
      padding: [theme.spacing.large, theme.spacing.medium],
    },
  },
  hideOnMobile: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  rootMobileNoImage: {
    [theme.breakpoints.down('sm')]: {
      backgroundImage: 'none !important',
    },
  },
  withOpenDialog: {
    [theme.breakpoints.down('sm')]: {
      zIndex: 5,
      WebkitTransform: 'scale(1)',
      position: 'fixed',
      top: 0,
      left: 0,
      bottom: 0,
    },
  },
});

export default injectSheet(stylesheet)(Section);



// WEBPACK FOOTER //
// ./src/site-render/src/Section/Section.js